import React from 'react'
import { Field } from 'formik'
import styled from 'styled-components'

import Input from './Input/index'
import ItemsToggle from './ItemsToggle'
import Label from './Label'
import name from './lib/name'

const Container = styled.div`
  display: flex;
  flex-shrink: 1;
`

export default ({ baseName, toggle, on, items, isItem, ...rest }) => (
  <Field name={name(baseName)}>
    {(fieldProps) => (
      <Container>
        <Input {...fieldProps} baseName={baseName} isItem={isItem} />
        {items && <ItemsToggle toggle={toggle} on={on} {...rest} />}
        <Label baseName={baseName} items={items} {...rest} />
      </Container>
    )}
  </Field>
)
